import "./scorecardNews.css";
import "../../index.css";
import { useState, useEffect } from "react";
import ScorecardHomeSubHeader from "./ScorecardHome/scorecardHomeSubHeader";
import PopUpModal from "../../popUpForms/formModals/popUpFormModal";
import PopUpFormDownloadScorecard from "../../popUpForms/popUpFormDownloadScorecard";

const ScorecardNews = () => {
  const [popUpFormVisible, setPopUpFormVisible] = useState(false);
  const [activeForm, setActiveForm] = useState("");

  const handleShowPopUpForm = (id) => {
    setActiveForm(id);
    setPopUpFormVisible(true);
  };

  return (
    <>
      <ScorecardHomeSubHeader />
      <div className="scorecard-news">
        <h2>Press Release - Launching the Scorecard</h2>
        <p>
          {" "}
          Groundbreaking New Wildfire Resilience Scorecard Empowers Communities
          to Assess Wildfire Risk, Boost Preparedness.
        </p>
        <p>
          Global Rollout Kicks Off With Pilot Program to Test Methodology.
          Participants Wanted
        </p>
        <p>
          For Immediate Release <br />
          February 19, 2024 - (San Francisco, CA) Communities worldwide now have
          a new tool to evaluate wildfire risk and strengthen resilience with
          the introduction of Community Wildfire Resilience Scorecard by
          ARISE-US and CrowdDoing Catastrophic Wildfire Prevention Consortium
          (CWPC).
        </p>

        <p>
          The Community Wildfire Resilience Scorecard enables assessment of
          wildfire risk across property, community and landscape scales.
          Developed collaboratively by wildfire experts, ARISE-US and CWPC, the
          open-source scorecard provides a robust set of questions to develop a
          baseline assessment, identify risks, and contribute to creating
          targeted plans, and driving unified action.
        </p>

        <p>
          View and download the Community Wildfire Resilience Scorecard
          published by the United Nations Office for Disaster Risk Reductions
          (UNDRR) PreventionWeb:{" "}
          <a
            href="https://www.preventionweb.net/publication/wildfire-resilience-scorecard"
            target="_blank"
            rel="noreferrer"
          >
            Community Wildfire Resilience Scorecard
          </a>
          .
        </p>

        <p>
          The Wildfire Resilience Scorecard incorporates cutting-edge resilience
          principles across land use planning, infrastructure hardening, public
          education, governance, nature-based solutions, ecosystem management,
          and post-disaster recovery capacity. This comprehensive approach
          prepares communities to develop targeted plans to substantially reduce
          wildfire risks through integrated planning, mitigation, and
          governance.
        </p>

        <p>
          Global rollout starts with a pilot program enabling communities
          worldwide to test and refine the scorecard. In addition to
          communities, we invite diverse stakeholders - governments, companies,
          associations - to adopt the Wildfire Resilience Scorecard, collaborate
          to improve it through feedback and pilots, and build collaborative
          resilience strategies against increasingly devastating wildfires.
        </p>

        <p>
          “Community collaboration is critical for preventing catastrophic
          wildfires. Help us make communities more resilient. Pilot with us.
          Send feedback, collaborate, share data, learnings and best practices
          to accelerate our progress.” said Claudia Brenner, Co-CEO CrowdDoing
          CWPC.
        </p>

        <p>
          Download the scorecard{" "}
          <a
            href="javascript:void(0)"
            onClick={() => handleShowPopUpForm("scorecard-download")}
          >
            here
          </a>
          . Collaborate, send feedback and learn more at{" "}
          <a href="/scorecard/contact">Contact Us</a>
        </p>

        <p>
          "By building systems change strategies with global collaborators, we
          empower communities to understand risks through the scorecard.
          Together we can reduce catastrophic wildfire risks and build
          prevention pathways for a hotter, drier, fire-prone world," said Bobby
          Fishkin, Co-CEO of Catastrophic Wildfire Prevention at CrowdDoing &
          Co-leader of CrowdDoing.
        </p>

        <p>
          “Many communities either don’t have the information they need to
          understand and improve their wildfire risk, or they have too much, in
          too many places and too complex to understand. The Scorecard is the
          first piece of a strategy to create a free “one stop shop” for the
          integrated information and expertise that communities will need. The
          Scorecard allows a community to see how it is placed currently with
          respect to wildfire risk. Other pieces will help it select strategies
          and actions to move forward and improve their risk and resilience,”
          said Peter Williams, Chair of ARISE-US.
        </p>

        <p>
          This groundbreaking scorecard is a gift to reduce disaster risk
          worldwide. Join the movement for resilience. Contact us at{" "}
          <a
            className="allow-word-break"
            href="mailto:contact@preventwildfire.world"
          >
            contact@preventwildfire.world
          </a>
        </p>

        <p>
          ARISE, the Private Sector Alliance for Disaster Resilient Societies,
          is a network of private sector entities led by the{" "}
          <a href="https://www.undrr.org/" target="_blank" rel="noreferrer">
            UN Office for Disaster Risk Reduction (UNDRR)
          </a>
          . In 2015, UNDRR started ARISE to support the private sector to become
          a key partner in reducing disaster risk. It has grown to over 400
          members and over 29 networks across the world. ARISE-US is the US
          Network of ARISE.
        </p>

        <p>
          Catastrophic Wildfire Prevention Consortium (CWPC) at CrowdDoing is a
          cross-sector, international consortium of wildfire experts,
          institutions, entrepreneurs and volunteers with a goal of preventing
          catastrophic wildfires through a portfolio of tailored, integrated
          innovations for communities.
        </p>

        <p>
          Claudia Brenner, Co-CEO CrowdDoing Catastrophic Wildfire Prevention
          Consortium <br />
          <a
            href="https://www.linkedin.com/in/claudia-brenner/"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-link"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <br />
          <span className="allow-word-break">
            {" "}
            cbrenner@atomicstrategicdesign.com
          </span>
        </p>

        <p>
          Bobby Fishkin, CEO CrowdDoing <br />
          <a
            href="https://www.linkedin.com/in/bobbyfishkin/"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-link"
          >
            <i className="fab fa-linkedin"></i>
          </a>{" "}
          <br />
          bobby@reframeit.com
        </p>

        <PopUpModal
          activeForm={activeForm}
          formActiveState={popUpFormVisible}
          setFormActiveState={setPopUpFormVisible}
        >
          <PopUpFormDownloadScorecard />
        </PopUpModal>
      </div>
    </>
  );
};

export default ScorecardNews;
